import React from 'react'
import { Card } from 'react-bootstrap'

import PropTypes from 'prop-types'

const AwaitingLabellingArticleList = ({ items }) => {
	return (
		<div className="awaiting-labelling-task-list">
			<h4>Pallet Contents</h4>
			{items?.map((item, idx) => (
				<Card key={item.id || idx} className="awaiting-labelling-task-card mb-3">
					<Card.Body>
						<div className="infodesc">{item.shortArticleText || item.articleText}</div>
						<div className="awaiting-labelling-task-row">
							<span className="awaiting-labelling-task-label">ArticleId:</span>
							<span className="awaiting-labelling-task-value">{item.articleId}</span>
						</div>
						<div className="awaiting-labelling-task-row">
							<span className="awaiting-labelling-task-label">OrderIds:</span>
							<span className="awaiting-labelling-task-value">{item.orderIds}</span>
						</div>
						<div className="awaiting-labelling-task-row">
							<span className="awaiting-labelling-task-label">Supplier No:</span>
							<span className="awaiting-labelling-task-value">{item.supplierArticleId}</span>
						</div>
						<div className="awaiting-labelling-task-row">
							<span className="awaiting-labelling-task-label">Picked Quantity:</span>
							<span className="awaiting-labelling-task-value">{item.quantityPicked}</span>
						</div>
						<div className="awaiting-labelling-task-row">
							<span className="awaiting-labelling-task-label">Ordered Quantity:</span>
							<span className="awaiting-labelling-task-value">{item.quantityOrdered}</span>
						</div>
					</Card.Body>
				</Card>
			))}
		</div>
	)
}

AwaitingLabellingArticleList.propsTypes = {
	items: PropTypes.array.isRequired
}

export default AwaitingLabellingArticleList